import WsService from "../../WsService";
import InboundTransactionSearchDTO from "../../../domain/Transaction/inbound/InboundTransactionSearchDTO";
import UserSessionService from "../../UserSessionService";
import BasicAuthGenerator from "../../../utils/BasicAuthGenerator";
import MsisdnSearchStripper from "../../../utils/MsisdnSearchStripper";

const ENDPOINT_BASE = "/transactions/inbound";

export default class InboundTransactionSearchService {

    static findOrder(collectionPin, remittancePartner, phoneNumber) {

        let endpoint = ENDPOINT_BASE + "/search?reference=" + collectionPin + "&remittance-partner=" + remittancePartner + "&customer-identifier=" + MsisdnSearchStripper.stripMsisdn(phoneNumber);

        let registrationHeaders = UserSessionService.retrieveRegisteringAuth();
        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };

        return WsService.putWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new InboundTransactionSearchDTO(response)
            },
            response => {
                return response;
            });
    }
}
